Monitoring.Views ||= {}

class Monitoring.Views.ImageAttachmentLabelView extends Backbone.View
  template: JST['backbone/templates/image_attachment_label']

  events:
    'click #reset-image': 'resetImage'

  initialize: (@options = {}) ->
    @context = @options.context
    @image = @options.image

  render: ->
    @$el.append(@template({image: @image}))
    @$el.find('#image-preview-container').show()
    @$el

  resetImage: (event) ->
    @context.resetFile(@image)
    @remove()
